import { useState } from "react";
import { Minus, Plus, Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { ARTICLE_CATEGORIES } from "@/components/concierge/categories";

const ArticleLine = ({ article, q, setQty }) => (
  <div className={`flex items-center justify-between rounded-lg border p-3 ${q ? "border-pink-300 bg-pink-50" : "bg-white"}`}>
    <div>
      <p className="font-medium">{article.name}</p>
      <p className="text-xs text-slate-500">{article.price.toFixed(2)} €</p>
    </div>
    <div className="flex items-center gap-3">
      <button type="button" onClick={() => setQty(article.id, Math.max(0, q - 1))} disabled={!q} className="w-9 h-9 rounded-full border flex items-center justify-center disabled:opacity-30" data-testid={`article-minus-${article.id}`}><Minus className="w-4 h-4" /></button>
      <span className="w-6 text-center font-bold" data-testid={`article-qty-${article.id}`}>{q}</span>
      <button type="button" onClick={() => setQty(article.id, q + 1)} className="w-9 h-9 rounded-full border flex items-center justify-center" data-testid={`article-plus-${article.id}`}><Plus className="w-4 h-4" /></button>
    </div>
  </div>
);

export const ArticlePicker = ({ articles, quantities, setQty }) => {
  const [category, setCategory] = useState("all");
  const [search, setSearch] = useState("");
  const s = search.trim().toLowerCase();
  const visible = articles.filter((a) => (category === "all" || (a.category || "Vêtements") === category) && a.name.toLowerCase().includes(s));
  const count = (c) => articles.filter((a) => (a.category || "Vêtements") === c).reduce((n, a) => n + (quantities[a.id] || 0), 0);
  const tabs = [["all", "Tous"], ...ARTICLE_CATEGORIES.map((c) => [c, c])];

  return (
    <div className="space-y-3" data-testid="concierge-article-picker">
      <div className="flex gap-2 flex-wrap">
        {tabs.map(([key, label]) => {
          const n = key === "all" ? 0 : count(key);
          return (
            <button key={key} type="button" onClick={() => setCategory(key)} data-testid={`article-category-tab-${key}`}
              className={`px-4 py-2 rounded-full text-sm font-semibold border transition-colors ${category === key ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600"}`}>
              {label}{n > 0 && <span className="ml-1 bg-pink-600 text-white rounded-full px-1.5 text-xs">{n}</span>}
            </button>
          );
        })}
      </div>
      <div className="relative">
        <Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" />
        <Input className="pl-9" placeholder="Rechercher un article..." value={search} onChange={(e) => setSearch(e.target.value)} data-testid="article-search-input" />
      </div>
      <div className="space-y-2">
        {visible.map((a) => <ArticleLine key={a.id} article={a} q={quantities[a.id] || 0} setQty={setQty} />)}
      </div>
      {visible.length === 0 && <p className="text-center text-slate-400 py-4">Aucun article trouvé</p>}
    </div>
  );
};
